/** Все пары key=value из строки (например сегмент пути вида a=1&b=2). */
export const getAllFilterParams = (search) => {
  const params = new URLSearchParams(search ?? '')
  const result = {}
  params.forEach((value, key) => {
    if (value) {
      result[key] = value
    }
  })
  return result
}
